module.exports = __webpack_public_path__ + "static/media/nita_logo.60e5f324.png";